.ux-modal-content {
  display: block;
  flex: 1 1 auto;
  overflow: auto;
  padding: 0 $dim-30 $dim-30;
  width: 100%;

  p {
    color: $color-gray-text;
  }
}
